(function () {
  'use strict';

  // Tekster og rod-URL kommer fra layout/theme.liquid (window.theme), så de
  // følger sproget og marknadens undermappe (/da-dk/).
  var themeData = window.theme || {};
  var ROOT = themeData.root || '/';
  function t(key, vars) {
    var s = (themeData.strings && themeData.strings[key]) || key;
    if (vars) Object.keys(vars).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s;
  }

  // Samme format som Liquids | money: "1 099,99 kr" i Sverige, "1.099,99 kr" i
  // Danmark. Andre valutaer overlades til Intl.
  function formatShopMoney(cents) {
    var currency = themeData.currency || 'SEK';
    var locale = themeData.locale || 'sv';
    if (currency === 'SEK' || currency === 'DKK' || currency === 'NOK') {
      return (cents / 100).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr';
    }
    return (cents / 100).toLocaleString(locale, { style: 'currency', currency: currency });
  }

  // Faste rabatbeløb (fx "50 kr på filtrene") ligger i temaet i butikkens
  // valuta, SEK. Shopify omregner rabatten i kassen med dagskursen, så visningen
  // skal gøre det samme, ellers står der 50 kr på siden og 34 kr i kassan.
  function toPresentment(shopCents) {
    var rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    return Math.round(shopCents * rate);
  }

  /* ---------- Sticky header shadow ---------- */
  var siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    var onScroll = function () {
      siteHeader.classList.toggle('is-scrolled', window.scrollY > 4);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Scroll reveal ---------- */
  var revealTargets = document.querySelectorAll(
    '.feature-card, .review-card, .faq__item, .hero__content, .hero__media, .cta-banner__content, .cta-banner__media, .product-gallery, .product-info'
  );
  if ('IntersectionObserver' in window && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    document.documentElement.classList.add('js-reveal');
    revealTargets.forEach(function (el) { el.classList.add('reveal'); });
    var revealAll = function () {
      revealTargets.forEach(function (el) { el.classList.add('is-visible'); });
    };
    // Failsafe: if the observer never fires (hidden tab, prerender, headless
    // screenshot, blocked frames) the page must not stay blank.
    setTimeout(revealAll, 2500);
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    revealTargets.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- Looping background video ---------- */
  var loopVideos = document.querySelectorAll('video[autoplay]');

  // Bakgrundsvideorna ligger som data-src så att en halv megabyte inte hämtas
  // vid sidvisning på mobil, där de oftast ligger långt under första skärmen.
  // Källorna flyttas till src först när videon närmar sig skärmen. En video som
  // redan har vanliga src-attribut rörs inte.
  function hydrateVideo(v) {
    if (v.dataset.srcLoaded) { return; }
    var deferred = v.querySelectorAll('source[data-src]');
    if (!deferred.length) { v.dataset.srcLoaded = '1'; return; }
    deferred.forEach(function (s) {
      s.setAttribute('src', s.dataset.src);
      s.removeAttribute('data-src');
    });
    v.dataset.srcLoaded = '1';
    v.load();
  }

  // play() direkt efter load() avvisas, eftersom filen ännu inte är buffrad, och
  // ett avvisat play() nollar webbläsarens egen autoplay-flagga för gott. Då blir
  // rutan stillastående. Därför väntas det på canplay när datan inte finns än.
  function playVideo(v) {
    hydrateVideo(v);
    var start = function () {
      var p = v.play();
      if (p && p.catch) { p.catch(function () {}); }
    };
    if (v.readyState >= 2) { start(); }
    else { v.addEventListener('canplay', start, { once: true }); }
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    loopVideos.forEach(function (v) {
      v.removeAttribute('autoplay');
      // Utan hämtning blir rutan tom för den som valt mindre rörelse, så
      // filen laddas ändå men får stå still på första bilden.
      hydrateVideo(v);
      v.pause();
    });
  } else if ('IntersectionObserver' in window) {
    // Chrome defers autoplay for offscreen video and does not always resume it,
    // so playback is driven explicitly instead of relying on the attribute.
    var videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          playVideo(v);
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.2, rootMargin: '200px 0px' });
    loopVideos.forEach(function (v) { videoObserver.observe(v); });
  } else {
    // Ingen IntersectionObserver: hämta direkt så att videon aldrig uteblir.
    loopVideos.forEach(hydrateVideo);
  }

  /* ---------- Mobile menu ---------- */
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  document.querySelectorAll('[data-mobile-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      mobileMenu && mobileMenu.setAttribute('data-open', '');
    });
  });
  document.querySelectorAll('[data-mobile-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      mobileMenu && mobileMenu.removeAttribute('data-open');
    });
  });

  /* ---------- Cart ----------
     Hele kurven ligger i sektionen 'cart-drawer'. Hver mutation sender
     sections=cart-drawer med, så Shopify returnerer den nye HTML i samme svar.
     Før kostede ét klik på plus tre requests og et fuldt DOM-skift der
     nulstillede scrollpositionen. Nu: ét request, bevaret scroll, og antallet
     opdateres optimistisk med det samme så knappen føles øjeblikkelig. */

  var CART_SECTION = 'cart-drawer';
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartLastFocus = null;
  var cartPending = 0;
  var cartUndoTimer = null;

  function cartContentNodes() {
    return document.querySelectorAll('[data-cart-content]');
  }

  function openCartDrawer(opener) {
    if (!cartDrawer) return;
    // Elementet der åbnede drawer'en, ikke document.activeElement: Safari
    // fokuserer ikke altid en knap ved klik, og så havner fokus i body ved
    // lukning i stedet for at vende tilbage til kundvagnsikonet.
    cartLastFocus = opener || document.activeElement;
    cartDrawer.setAttribute('data-open', '');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    // Lukkeknappen, ikke kassaknappen: Enter lige efter åbning må ikke
    // sende kunden direkte i checkout.
    var focusTarget = cartDrawer.querySelector('.cart-drawer__close');
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.removeAttribute('data-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    if (cartLastFocus && typeof cartLastFocus.focus === 'function') {
      cartLastFocus.focus({ preventScroll: true });
      cartLastFocus = null;
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-drawer-open]');
    if (opener) {
      e.preventDefault();
      openCartDrawer(opener);
    }
    // Knappen "Fortsätt handla" ligger også på /cart, hvor der ikke er nogen
    // drawer at lukke. Der skal den i stedet føre videre til butikken.
    var closer = e.target.closest('[data-cart-drawer-close]');
    if (closer) {
      if (cartDrawer && cartDrawer.hasAttribute('data-open')) {
        e.preventDefault();
        closeCartDrawer();
      } else if (closer.tagName === 'BUTTON') {
        e.preventDefault();
        window.location.href = closer.getAttribute('data-href') || ROOT + 'collections/all';
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!cartDrawer || !cartDrawer.hasAttribute('data-open')) return;

    if (e.key === 'Escape') {
      closeCartDrawer();
      return;
    }

    // Fokusfælde: uden den vandrer tabulator ned i siden bag overlayet,
    // hvor skærmlæsere og tastaturbrugere ikke kan se hvor de er.
    if (e.key !== 'Tab') return;
    var panel = cartDrawer.querySelector('[data-cart-drawer-panel]');
    if (!panel) return;
    var focusables = panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.toggleAttribute('data-empty', !count);
    });
  }

  function setCartBusy(busy) {
    cartPending += busy ? 1 : -1;
    if (cartPending < 0) cartPending = 0;
    cartContentNodes().forEach(function (node) {
      node.toggleAttribute('data-cart-busy', cartPending > 0);
    });
  }

  function renderCartSection(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');

    // /cart/add.js svarer med varelinjen, ikke med kurven, så data.item_count
    // findes ikke ved en tilføjelse. Antallet læses derfor ud af den friske
    // sektion, som altid har det rigtige tal.
    var freshCount = doc.querySelector('[data-cart-count]');
    if (freshCount) updateCartCount(parseInt(freshCount.textContent, 10) || 0);

    var fresh = doc.querySelector('[data-cart-content]');
    if (!fresh) return;
    cartContentNodes().forEach(function (node) {
      // Scrollpositionen skal overleve. Ellers hopper listen til toppen hver
      // gang man trykker plus på den nederste vare.
      var oldScroll = node.querySelector('.cart-contents__scroll');
      var offset = oldScroll ? oldScroll.scrollTop : 0;
      node.innerHTML = fresh.innerHTML;
      var newScroll = node.querySelector('.cart-contents__scroll');
      if (newScroll) newScroll.scrollTop = offset;
    });
    // Shop Pay/Apple Pay-knapperne er custom elements. Efter innerHTML skal de
    // initialiseres igen, ellers står feltet tomt.
    if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) {
      try { window.Shopify.PaymentButton.init(); } catch (err) { /* ingen wallets aktiveret */ }
    }
  }

  function showCartError(message) {
    var shown = false;
    document.querySelectorAll('[data-cart-error]').forEach(function (el) {
      el.textContent = message;
      el.hidden = false;
      shown = true;
    });
    if (!shown) window.alert(message);
  }

  function cartRequest(url, payload) {
    payload.sections = CART_SECTION;
    payload.sections_url = window.location.pathname;
    setCartBusy(true);
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        if (typeof data.item_count === 'number') updateCartCount(data.item_count);
        if (data.sections) renderCartSection(data.sections[CART_SECTION]);
        return data;
      })
      .finally(function () { setCartBusy(false); });
  }

  function cartAddItems(items) {
    return cartRequest(ROOT + 'cart/add.js', { items: items });
  }

  function cartAdd(id, quantity) {
    return cartRequest(ROOT + 'cart/add.js', { items: [{ id: id, quantity: quantity }] });
  }

  function cartChange(key, quantity) {
    return cartRequest(ROOT + 'cart/change.js', { id: key, quantity: quantity });
  }

  function showCartUndo(message, variantId, quantity) {
    document.querySelectorAll('[data-cart-undo]').forEach(function (box) {
      var text = box.querySelector('[data-cart-undo-text]');
      var action = box.querySelector('[data-cart-undo-action]');
      if (text) text.textContent = message;
      if (action) {
        action.setAttribute('data-variant-id', variantId);
        action.setAttribute('data-quantity', quantity);
      }
      box.hidden = false;
    });
    clearTimeout(cartUndoTimer);
    cartUndoTimer = setTimeout(function () {
      document.querySelectorAll('[data-cart-undo]').forEach(function (box) { box.hidden = true; });
    }, 8000);
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cart-qty-change]');
    var removeBtn = e.target.closest('[data-cart-remove]');
    var upsellBtn = e.target.closest('[data-cart-upsell-add]');
    var undoBtn = e.target.closest('[data-cart-undo-action]');

    if (qtyBtn) {
      var key = qtyBtn.getAttribute('data-key');
      var delta = parseInt(qtyBtn.getAttribute('data-cart-qty-change'), 10);
      var valueEl = qtyBtn.closest('.cart-qty').querySelector('[data-cart-qty-value]');
      var current = parseInt(valueEl.textContent, 10) || 1;
      var next = Math.max(0, current + delta);
      // Optimistisk: tallet skifter før serveren svarer. Serverens svar
      // overskriver alligevel hele blokken, så en afvisning retter sig selv.
      valueEl.textContent = next;
      cartChange(key, next).catch(function () {
        valueEl.textContent = current;
        showCartError(t('cart_error_qty'));
      });
    }

    if (removeBtn) {
      var rKey = removeBtn.getAttribute('data-key');
      var rVariant = removeBtn.getAttribute('data-variant-id');
      var rQty = parseInt(removeBtn.getAttribute('data-quantity'), 10) || 1;
      var rTitle = removeBtn.getAttribute('data-title') || t('cart_item');
      // Linjer med egenskaber (fx en uploadet fil) kan ikke lægges tilbage
      // med add.js, for filen findes ikke længere. Så tilbydes ingen fortryd.
      var canUndo = removeBtn.getAttribute('data-has-properties') === 'false';
      cartChange(rKey, 0).then(function () {
        if (canUndo) showCartUndo(t('cart_removed', { title: rTitle }), rVariant, rQty);
      }).catch(function () {
        showCartError(t('cart_error_remove'));
      });
    }

    if (undoBtn) {
      undoBtn.disabled = true;
      cartAdd(parseInt(undoBtn.getAttribute('data-variant-id'), 10),
              parseInt(undoBtn.getAttribute('data-quantity'), 10) || 1)
        .catch(function () {
          undoBtn.disabled = false;
          showCartError(t('cart_error_undo'));
        });
    }

    if (upsellBtn && !upsellBtn.disabled) {
      upsellBtn.disabled = true;
      cartAdd(parseInt(upsellBtn.getAttribute('data-variant-id'), 10), 1)
        .catch(function () {
          upsellBtn.disabled = false;
          showCartError(t('cart_error_add'));
        });
    }
  });

  /* ---------- Product form: variants, gallery, add to cart ---------- */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    // Fall tillbaka på hela dokumentet: JSON-taggen har legat utanför sektionen,
    // vilket tystade variantvalet helt (fel färg hamnade i varukorgen).
    var jsonEl = section.querySelector('[data-product-json]') || document.querySelector('[data-product-json]');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var form = section.querySelector('[data-product-form]');
    var variantIdInput = section.querySelector('[data-product-variant-id]');
    var addToCartBtn = section.querySelector('[data-add-to-cart]');
    var addToCartText = section.querySelector('[data-add-to-cart-text]');
    var addedMessage = section.querySelector('[data-added-message]');
    var addError = section.querySelector('[data-add-error]');
    // Prisblock finns både i produktrutan och i den klistrande köp-baren, och baren
    // ligger utanför [data-product-section]. Samla dem globalt så paketpriset
    // uppdateras i båda, annars visar baren alltid variantens grundpris.
    var priceWraps = Array.prototype.slice.call(document.querySelectorAll('[data-product-price]'));
    var quantityInput = section.querySelector('[data-quantity-input] [data-quantity-value]');
    var bundleWrap = section.querySelector('[data-bundle-select]');
    var bundleColors = section.querySelector('[data-bundle-colors]');
    var colorSwatch = section.querySelector('[data-color-label]');
    var colorOptionIndex = colorSwatch ? parseInt(colorSwatch.getAttribute('data-option-index'), 10) : -1;
    var optionGroups = section.querySelectorAll('[data-option-name]');

    function getSelectedOptions() {
      var opts = [];
      optionGroups.forEach(function (group) {
        var selected = group.querySelector('.is-selected');
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        if (selected) opts[idx] = selected.getAttribute('data-option-value');
      });
      return opts;
    }

    function findVariant() {
      var selectedOptions = getSelectedOptions();
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return selectedOptions.every(function (val, i) { return val == null || opts[i] === val; });
      });
    }

    function formatMoney(cents) {
      return formatShopMoney(cents);
    }

    var currentVariant = null;
    var bundleQty = 1;
    var bundleDiscount = 0;
    var bundleDiscountAmount = 0;
    var bundleAddonVariantId = null;
    var bundleAddonQty = 0;
    var bundleAddonPrice = 0;
    // Gåvan: läggs i varukorgen, priset räknas in i fullpris och är redan
    // inräknat i data-bundle-discount-amount, så den blir gratis i visningen.
    var bundleGiftVariantId = null;
    var bundleGiftPrice = 0;
    // Valfri produkt (pick_any): kunden väljer en annan produkt till fullpris.
    // Priset räknas in i paketets fullpris; ingen rabatt på den.
    var pickPanel = section.querySelector('[data-bundle-pick-panel]');
    var giftSelect = section.querySelector('[data-bundle-gift-select]');
    var giftAnimal = section.querySelector('[data-bundle-gift-animal]');
    var bundlePick = false;
    var bundlePickVariantId = null;
    var bundlePickPrice = 0;

    // Läser vald produkt och variant ur väljaren. En produkt med flera varianter
    // har en egen <select>; annars gäller kortets standardvariant.
    function readPick() {
      if (!pickPanel) return;
      var item = pickPanel.querySelector('[data-bundle-pick-item].is-selected');
      if (!item) { bundlePickVariantId = null; bundlePickPrice = 0; return; }
      var id = item.getAttribute('data-bundle-pick-item');
      var price = parseInt(item.getAttribute('data-price'), 10) || 0;
      var variantId = item.getAttribute('data-variant-id');
      pickPanel.querySelectorAll('[data-bundle-pick-variants]').forEach(function (wrap) {
        var mine = wrap.getAttribute('data-bundle-pick-variants') === id;
        wrap.hidden = !mine;
        if (mine) {
          var opt = wrap.querySelector('select').selectedOptions[0];
          if (opt) { variantId = opt.value; price = parseInt(opt.getAttribute('data-price'), 10) || price; }
        }
      });
      var priceEl = item.querySelector('[data-bundle-pick-item-price]');
      if (priceEl) priceEl.textContent = formatMoney(price);
      bundlePickVariantId = variantId;
      bundlePickPrice = price;
    }

    // Paketkortet visar fullpris med den valda produkten inräknad, så det måste
    // målas om när kunden byter produkt, variant eller huvudvariant.
    function paintPickTier() {
      if (!bundleWrap || !currentVariant) return;
      var btn = bundleWrap.querySelector('[data-bundle-pick]');
      if (!btn) return;
      readPick();
      var qty = parseInt(btn.getAttribute('data-bundle-qty'), 10) || 1;
      var giftPrice = parseInt(btn.getAttribute('data-bundle-gift-price'), 10) || 0;
      var full = currentVariant.price * qty + bundlePickPrice + giftPrice;
      var disc = readBundleDiscount(btn);
      var set = function (sel, text) { var el = btn.querySelector(sel); if (el) el.textContent = text; };
      set('[data-bundle-price-was]', formatMoney(full));
      set('[data-bundle-price-now]', formatMoney(Math.max(0, full - disc)));
    }

    // Gemensamt för klick och startläge: valfri produkt och gåvans storlek.
    function syncPickForOption(btn) {
      bundlePick = !!(btn && btn.hasAttribute('data-bundle-pick'));
      if (pickPanel) pickPanel.hidden = !bundlePick;
      if (bundlePick) {
        readPick();
        if (giftSelect && bundleGiftVariantId) bundleGiftVariantId = giftSelect.value;
      } else {
        bundlePickVariantId = null;
        bundlePickPrice = 0;
      }
    }

    // Visat pris = variantpris x antal i paketet, plus ev. tillägg, minus paketrabatten.
    // Procentmärket i galleriet renderas serverside från varianten. Utan detta
    // står det kvar på variantens procent medan prisraden visar paketets pris,
    // så de två siffrorna säger olika saker om samma erbjudande.
    function paintGalleryDiscount(now, was) {
      var badge = document.querySelector('[data-gallery-discount]');
      if (!badge) return;
      if (was > now) {
        badge.textContent = '-' + Math.round((was - now) * 100 / was) + '%';
        badge.style.display = '';
      } else {
        badge.style.display = 'none';
      }
    }

    function paintPrice(priceWrap, now, was) {
      paintGalleryDiscount(now, was);
      var current = priceWrap.querySelector('[data-price-current]');
      var compare = priceWrap.querySelector('[data-price-compare]');
      var badge = priceWrap.querySelector('[data-price-badge]');
      var priceRow = priceWrap.querySelector('[data-price-row]') || priceWrap;

      if (current) current.textContent = formatMoney(now);

      if (was > now) {
        if (!compare) {
          compare = document.createElement('span');
          compare.className = 'price__compare';
          compare.setAttribute('data-price-compare', '');
          priceWrap.insertBefore(compare, priceWrap.firstChild);
        }
        compare.textContent = formatMoney(was);
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'price__badge';
          badge.setAttribute('data-price-badge', '');
          priceRow.appendChild(badge);
        }
        badge.textContent = t('save', { amount: formatMoney(was - now) });
      } else {
        if (compare) compare.remove();
        if (badge) badge.remove();
      }
    }

    // Checklistan under köpknappen kan variera med valt paket: punkter märkta
    // addon_only/base_only visas bara för paket med respektive utan tillägg.
    var highlightRows = Array.prototype.slice.call(document.querySelectorAll('[data-highlight-visibility]'));
    function syncHighlights() {
      if (!highlightRows.length) return;
      var hasAddon = !!bundleAddonVariantId;
      highlightRows.forEach(function (row) {
        var mode = row.getAttribute('data-highlight-visibility') || 'always';
        var show = mode === 'always' || (mode === 'addon_only' && hasAddon) || (mode === 'base_only' && !hasAddon);
        row.hidden = !show;
      });
    }

    function renderPrice() {
      if (!priceWraps.length || !currentVariant) return;

      var pickPart = bundlePick ? bundlePickPrice : 0;
      var full = (currentVariant.price * bundleQty) + (bundleAddonQty * bundleAddonPrice) + bundleGiftPrice + pickPart;
      // Procentrabatten rundas ned pr. styk, som Shopify gör i kassan och som kortet i Liquid.
      var unitPart = currentVariant.price * bundleQty;
      var pctDisc = Math.floor(currentVariant.price * bundleDiscount / 100) * bundleQty + Math.floor((full - unitPart) * bundleDiscount / 100);
      var now = bundleDiscountAmount > 0 ? Math.max(0, full - bundleDiscountAmount) : full - pctDisc;
      var compareAt = currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price
        ? (currentVariant.compare_at_price * bundleQty) + (bundleAddonQty * bundleAddonPrice) + bundleGiftPrice + pickPart
        : 0;
      var was = Math.max(compareAt, (bundleDiscount > 0 || bundleDiscountAmount > 0) ? full : 0);

      priceWraps.forEach(function (wrap) { paintPrice(wrap, now, was); });
    }

    // Är den valda varianten själv ett pakettillägg (reservfiltren på fontänen),
    // blir "fontän + filter" i stället "filter + filter" och kassans rabatt gäller
    // inte. Då döljs paketväljaren och det första paketet utan tillägg väljs.
    function syncBundleForVariant(variant) {
      if (!bundleWrap || !variant) return;
      var isAddon = !!bundleWrap.querySelector('[data-bundle-addon-variant="' + variant.id + '"]');
      // pick_exclude_variants: varianten får inte ingå i gåvopaketet (reservfiltret).
      var hideList = bundleWrap.getAttribute('data-bundle-hide-variants') || '';
      var isExcluded = hideList.indexOf('|' + variant.id + '|') > -1;
      bundleWrap.style.display = (isAddon || isExcluded) ? 'none' : '';
      if ((isAddon && bundleAddonVariantId) || (isExcluded && (bundleGiftVariantId || bundlePick || bundleAddonVariantId))) {
        var plain = bundleWrap.querySelector('[data-bundle-option]:not([data-bundle-addon-variant]):not([data-bundle-pick]):not([data-bundle-gift-variant])');
        if (plain) plain.click();
      }
    }

    function updateForVariant(variant) {
      if (!variant) return;
      currentVariant = variant;
      variantIdInput.value = variant.id;
      syncBundleForVariant(variant);
      paintPickTier();

      renderPrice();

      if (variant.featured_media) {
        var img = section.querySelector('[data-gallery-image][data-media-id="' + variant.featured_media.id + '"]');
        // Bilden får bara aktiveras om den inte är bortfiltrerad av färgvalet,
        // annars blir huvudbilden tom (is-color-hidden = display:none).
        if (img && !img.classList.contains('is-color-hidden')) {
          setActiveMedia(variant.featured_media.id);
        }
      }

      var available = variant.available;
      if (addToCartBtn) {
        addToCartBtn.disabled = !available;
        if (addToCartText) addToCartText.textContent = available ? t('add_to_cart') : t('sold_out');
      }

      // Parpaketets "1 hänge"-kort ska visa vilken design som faktiskt är vald.
      var pairSingleDesign = section.querySelector('[data-pair-single-design]');
      var pairSinglePrice = section.querySelector('[data-pair-single-price]');
      if (pairSingleDesign) pairSingleDesign.textContent = '(' + variant.title + ')';
      if (pairSinglePrice) pairSinglePrice.textContent = formatMoney(variant.price);

      // En variant som i praktiken är två artiklar (t.ex. "Couple") visar en
      // andra bilduppladdning i samma formulär i stället för ett andra varukorgstillägg.
      var secondBlock = section.querySelector('[data-personalization-second]');
      if (secondBlock) {
        var triggerValue = secondBlock.getAttribute('data-personalization-second');
        var show = variant.title === triggerValue;
        secondBlock.hidden = !show;
        var file2 = secondBlock.querySelector('[data-personalization-file-2]');
        var note2 = secondBlock.querySelector('input[type="text"]');
        if (file2) { file2.disabled = !show; file2.required = show; }
        if (note2) { note2.disabled = !show; }
      }
    }

    function bundleColorRows() {
      return bundleColors ? Array.prototype.slice.call(bundleColors.querySelectorAll('[data-bundle-color-row]')) : [];
    }

    // Visa ett färgval per enhet i paketet. Rad 1 följer huvudfärgen; resten väljs fritt.
    function showBundleColorRows(qty) {
      if (!bundleColors) return;
      bundleColors.hidden = qty < 2;
      bundleColorRows().forEach(function (row, i) {
        row.hidden = i >= qty;
      });
    }

    function syncFirstBundleColor(colorValue) {
      var rows = bundleColorRows();
      if (!rows.length) return;
      rows[0].querySelectorAll('[data-bundle-color]').forEach(function (b) {
        var on = b.getAttribute('data-bundle-color') === colorValue;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    // Slår ihop de valda färgerna till rader för /cart/add.js.
    function bundleColorItems(qty) {
      var rows = bundleColorRows().slice(0, qty);
      if (rows.length < qty) return null;
      var counts = {};
      var order = [];
      for (var i = 0; i < rows.length; i++) {
        var chosen = rows[i].querySelector('[data-bundle-color].is-selected');
        if (!chosen) return null;
        var variant = variants.find(function (v) {
          return [v.option1, v.option2, v.option3][colorOptionIndex] === chosen.getAttribute('data-bundle-color');
        });
        if (!variant) return null;
        if (!counts[variant.id]) { counts[variant.id] = 0; order.push(variant.id); }
        counts[variant.id] += 1;
      }
      return order.map(function (id) { return { id: id, quantity: counts[id] }; });
    }

    // Webbläsaren avgör vid sidladdning vilka loading="lazy"-bilder som ska hämtas.
    // Galleribilderna ligger staplade med position:absolute och opacity:0, så alla
    // utom den aktiva hoppas över - och att byta klass efteråt är bara en målning,
    // inget som får hämtningen att starta. Utan det här fick den som tryckte
    // "nästa" en tom ruta som aldrig fylldes, eftersom ingen request någonsin gick.
    // Att sätta loading="eager" på en bild som ännu inte hämtats startar den.
    function forceLoadGalleryImage(img) {
      if (!img || img.dataset.forced) { return; }
      if (img.complete && img.naturalWidth) { img.dataset.forced = '1'; return; }
      img.dataset.forced = '1';
      img.setAttribute('loading', 'eager');
      var src = img.getAttribute('src');
      if (src) { img.setAttribute('src', src); }
    }

    function setActiveMedia(mediaId) {
      var id = String(mediaId);
      var all = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-image]'));
      all.forEach(function (img) {
        img.classList.toggle('is-active', img.getAttribute('data-media-id') === id);
      });
      section.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-media-id') === id);
      });

      // Den aktiva bilden måste hämtas nu. Grannarna hämtas också, så nästa
      // svep visas direkt i stället för att börja med en tom ruta.
      var visible = visibleGalleryImages();
      var active = section.querySelector('[data-gallery-image].is-active');
      var i = visible.indexOf(active);
      forceLoadGalleryImage(active);
      if (i !== -1 && visible.length > 1) {
        forceLoadGalleryImage(visible[(i + 1) % visible.length]);
        forceLoadGalleryImage(visible[(i - 1 + visible.length) % visible.length]);
      }

      scrollActiveThumbIntoView();
    }

    // Miniatyrraden svämmar över; utan detta hamnar den aktiva bilden utanför vyn.
    function scrollActiveThumbIntoView() {
      var strip = section.querySelector('.product-gallery__thumbs');
      var active = section.querySelector('[data-gallery-thumb].is-active');
      if (!strip || !active) return;
      var stripRect = strip.getBoundingClientRect();
      var thumbRect = active.getBoundingClientRect();
      var target = strip.scrollLeft;
      if (thumbRect.left < stripRect.left) {
        target -= (stripRect.left - thumbRect.left) + 10;
      } else if (thumbRect.right > stripRect.right) {
        target += (thumbRect.right - stripRect.right) + 10;
      }
      if (target !== strip.scrollLeft) {
        strip.scrollLeft = Math.max(0, target);
      }
    }

    function visibleGalleryImages() {
      return Array.prototype.slice.call(section.querySelectorAll('[data-gallery-image]')).filter(function (i) {
        return !i.classList.contains('is-color-hidden');
      });
    }

    function stepGallery(direction) {
      var visible = visibleGalleryImages();
      if (visible.length < 2) return;
      var active = section.querySelector('[data-gallery-image].is-active');
      var index = visible.indexOf(active);
      if (index === -1) index = 0;
      var next = (index + direction + visible.length) % visible.length;
      setActiveMedia(visible[next].getAttribute('data-media-id'));
    }

    function filterGalleryByColor(colorValue) {
      var images = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-image]'));
      var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-thumb]'));
      // data-media-colors är avgränsad (|Grön|Blå|) så "Grön" inte matchar "Mörkgrön".
      var matches = function (el) {
        var colors = el.getAttribute('data-media-colors') || '';
        return colors === '' || colors.indexOf('|' + colorValue + '|') !== -1;
      };
      var isColorSpecific = function (el) {
        return (el.getAttribute('data-media-colors') || '') !== '';
      };

      // data-show-all-colors: alla bilder syns alltid, färgvalet hoppar bara.
      var gallery = section.querySelector('[data-product-gallery]');
      var showAll = gallery && gallery.hasAttribute('data-show-all-colors');
      images.forEach(function (img) { img.classList.toggle('is-color-hidden', !showAll && !matches(img)); });
      thumbs.forEach(function (t) { t.classList.toggle('is-color-hidden', !showAll && !matches(t)); });

      // Hoppa alltid till färgens egen bild, annars ligger en delad bild kvar
      // som aktiv och färgbytet syns inte.
      var target = images.filter(function (img) { return matches(img) && isColorSpecific(img); })[0]
        || images.filter(matches)[0];
      if (target) setActiveMedia(target.getAttribute('data-media-id'));
    }

    section.addEventListener('click', function (e) {
      // Delad väljare (snippets/split-choice.liquid): hitta den variant vars titel
      // innehåller alla valda värden och klicka på dess dolda pill, så att pris,
      // galleri och köpknapp går genom samma kod som annars.
      var splitBtn = e.target.closest('[data-split-match]');
      if (splitBtn) {
        splitBtn.parentElement.querySelectorAll('[data-split-match]').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        splitBtn.classList.add('is-selected');
        splitBtn.setAttribute('aria-pressed', 'true');
        var splitLabel = splitBtn.closest('[data-split-group]').querySelector('[data-split-label]');
        if (splitLabel) splitLabel.textContent = splitBtn.getAttribute('data-split-text');
        var wanted = Array.prototype.map.call(
          section.querySelectorAll('[data-split-group] [data-split-match].is-selected'),
          function (b) { return b.getAttribute('data-split-match'); }
        );
        var pills = section.querySelectorAll('[data-option-name] [data-option-value]');
        var pill = Array.prototype.filter.call(pills, function (b) {
          var t = b.getAttribute('data-option-value').toLowerCase();
          return wanted.every(function (w) { return t.indexOf(w) > -1; });
        })[0];
        if (!pill) {
          // The combination doesn't exist (e.g. White with buttons). Keep the value
          // just clicked, take the first variant that has it, and move the other
          // rows to match, so the selection never shows a variant that isn't in the cart.
          var clicked = splitBtn.getAttribute('data-split-match');
          pill = Array.prototype.filter.call(pills, function (b) {
            return b.getAttribute('data-option-value').toLowerCase().indexOf(clicked) > -1;
          })[0];
          if (pill) {
            var pillValue = pill.getAttribute('data-option-value').toLowerCase();
            section.querySelectorAll('[data-split-group]').forEach(function (group) {
              if (group.contains(splitBtn)) return;
              group.querySelectorAll('[data-split-match]').forEach(function (b) {
                var on = pillValue.indexOf(b.getAttribute('data-split-match')) > -1;
                b.classList.toggle('is-selected', on);
                b.setAttribute('aria-pressed', on ? 'true' : 'false');
                var groupLabel = group.querySelector('[data-split-label]');
                if (on && groupLabel) groupLabel.textContent = b.getAttribute('data-split-text');
              });
            });
          }
        }
        if (pill) pill.click();
        return;
      }

      var optBtn = e.target.closest('[data-option-value]');
      if (optBtn) {
        var idx = parseInt(optBtn.getAttribute('data-option-index'), 10);
        // Knappen bär själv data-option-index, så closest() från knappen skulle
        // returnera knappen och aldrig gruppen, då avmarkeras aldrig de övriga.
        // Vi börjar därför sökningen hos föräldern.
        var group = (optBtn.parentElement && optBtn.parentElement.closest('[data-option-index]')) || optBtn.closest('[data-option-index]');
        group.querySelectorAll('[data-option-value]').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        optBtn.classList.add('is-selected');
        optBtn.setAttribute('aria-pressed', 'true');
        var label = group.closest('.product-form__option').querySelector('[data-selected-color-label]');
        if (label && optBtn.hasAttribute('data-color-label')) {
          label.textContent = optBtn.getAttribute('data-color-label');
        }
        if (optBtn.hasAttribute('data-color-label')) {
          filterGalleryByColor(optBtn.getAttribute('data-option-value'));
          syncFirstBundleColor(optBtn.getAttribute('data-option-value'));
        }
        updateForVariant(findVariant());
      }

      var bundleBtn = e.target.closest('[data-bundle-option]');
      if (bundleBtn && bundleWrap) {
        bundleWrap.querySelectorAll('[data-bundle-option]').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        bundleBtn.classList.add('is-selected');
        bundleBtn.setAttribute('aria-pressed', 'true');
        // Videorutan ligger som syskon och går från display:none till block här.
        // Hämtningen startas explicit i stället för att förlita sig på att
        // observern hinner fyra när elementet byter display.
        // CSS:en använder syskonselektorn .bundle-option.is-selected + .bundle-option__video,
        // så det är nästa syskon som blir synligt, inte första videon i gruppen.
        var bundleVideoWrap = bundleBtn.nextElementSibling;
        var bundleVideo = bundleVideoWrap && bundleVideoWrap.classList.contains('bundle-option__video')
          ? bundleVideoWrap.querySelector('video')
          : null;
        if (bundleVideo) { playVideo(bundleVideo); }
        var chosenQty = parseInt(bundleBtn.getAttribute('data-bundle-qty'), 10) || 1;
        if (quantityInput) {
          quantityInput.value = chosenQty;
        }
        bundleQty = chosenQty;
        bundleDiscount = parseInt(bundleBtn.getAttribute('data-bundle-discount'), 10) || 0;
        bundleDiscountAmount = readBundleDiscount(bundleBtn);
        bundleAddonVariantId = bundleBtn.getAttribute('data-bundle-addon-variant') || null;
        bundleAddonQty = bundleAddonVariantId ? (parseInt(bundleBtn.getAttribute('data-bundle-addon-qty'), 10) || 0) : 0;
        bundleAddonPrice = parseInt(bundleBtn.getAttribute('data-bundle-addon-price'), 10) || 0;
        bundleGiftVariantId = bundleBtn.getAttribute('data-bundle-gift-variant') || null;
        bundleGiftPrice = bundleGiftVariantId ? (parseInt(bundleBtn.getAttribute('data-bundle-gift-price'), 10) || 0) : 0;
        syncPickForOption(bundleBtn);
        showBundleColorRows(chosenQty);
        renderPrice();
        syncHighlights();
      }

      var pickItem = e.target.closest('[data-bundle-pick-item]');
      if (pickItem && pickPanel) {
        pickPanel.querySelectorAll('[data-bundle-pick-item]').forEach(function (b) {
          var on = b === pickItem;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        paintPickTier();
        renderPrice();
      }

      var bundleColorBtn = e.target.closest('[data-bundle-color]');
      if (bundleColorBtn) {
        var row = bundleColorBtn.closest('[data-bundle-color-row]');
        row.querySelectorAll('[data-bundle-color]').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        bundleColorBtn.classList.add('is-selected');
        bundleColorBtn.setAttribute('aria-pressed', 'true');
      }

      var thumb = e.target.closest('[data-gallery-thumb]');
      if (thumb) {
        setActiveMedia(thumb.getAttribute('data-media-id'));
      }

      if (e.target.closest('[data-gallery-prev]')) stepGallery(-1);
      if (e.target.closest('[data-gallery-next]')) stepGallery(1);
    });

    // setActiveMedia körs bara vid interaktion, så grannarna till startbilden
    // hämtas här. Annars är det just det första svepet som får vänta, och det
    // är det svep flest besökare gör. Vänta tills sidan är klar så att det inte
    // konkurrerar med startbilden.
    (function preloadGalleryNeighbours() {
      var run = function () {
        var visible = visibleGalleryImages();
        if (visible.length < 2) { return; }
        var active = section.querySelector('[data-gallery-image].is-active');
        var i = visible.indexOf(active);
        if (i === -1) { i = 0; }
        forceLoadGalleryImage(visible[(i + 1) % visible.length]);
        forceLoadGalleryImage(visible[(i - 1 + visible.length) % visible.length]);
      };
      if (document.readyState === 'complete') { setTimeout(run, 400); }
      else { window.addEventListener('load', function () { setTimeout(run, 400); }); }
    })();

    if (quantityInput) {
      var qtyWrap = quantityInput.closest('[data-quantity-input]');
      qtyWrap.addEventListener('click', function (e) {
        var current = parseInt(quantityInput.value, 10) || 1;
        if (e.target.closest('[data-quantity-decrease]')) {
          quantityInput.value = Math.max(1, current - 1);
        }
        if (e.target.closest('[data-quantity-increase]')) {
          quantityInput.value = current + 1;
        }
      });
    }

    // Svep på huvudbilden för mobil.
    var galleryMain = section.querySelector('.product-gallery__main');
    if (galleryMain) {
      var touchStartX = null;
      var touchStartY = null;
      galleryMain.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
        touchStartY = e.changedTouches[0].clientY;
      }, { passive: true });
      galleryMain.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        // Ignorera vertikala svep så sidan fortfarande går att skrolla.
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          stepGallery(dx < 0 ? 1 : -1);
        }
        touchStartX = null;
        touchStartY = null;
      }, { passive: true });
    }

    if (variantIdInput) {
      currentVariant = variants.filter(function (v) {
        return String(v.id) === String(variantIdInput.value);
      })[0] || null;
    }

    // data-bundle-discount-amount = fast rabat i SEK + gavens pris i kundens
    // valuta. Den faste del omregnes, så beløbet matcher kassen i DKK.
    function readBundleDiscount(btn) {
      var total = parseInt(btn.getAttribute('data-bundle-discount-amount'), 10) || 0;
      var fixed = parseInt(btn.getAttribute('data-bundle-discount-fixed'), 10) || 0;
      return total - fixed + toPresentment(fixed);
    }

    // Liquid kan ikke omregne valuta, så pakkekortene med fast rabat males om
    // her, når kunden handler i en anden valuta end butikkens.
    function repaintBundleOptions() {
      if (!bundleWrap || themeData.currency === themeData.shopCurrency) return;
      var unit = parseInt(bundleWrap.getAttribute('data-unit-price'), 10) || 0;
      bundleWrap.querySelectorAll('[data-bundle-option]').forEach(function (btn) {
        if (!(parseInt(btn.getAttribute('data-bundle-discount-fixed'), 10) > 0)) return;
        var qty = parseInt(btn.getAttribute('data-bundle-qty'), 10) || 1;
        var full = unit * qty + (parseInt(btn.getAttribute('data-bundle-addon-price'), 10) || 0) + (parseInt(btn.getAttribute('data-bundle-gift-price'), 10) || 0);
        var disc = readBundleDiscount(btn);
        var set = function (sel, text) { var el = btn.querySelector(sel); if (el) el.textContent = text; };
        set('[data-bundle-price-was]', formatMoney(full));
        set('[data-bundle-price-now]', formatMoney(Math.max(0, full - disc)));
        set('[data-bundle-save-badge]', '−' + formatMoney(disc));
        set('[data-bundle-save-text]', t('save', { amount: formatMoney(disc) }));
      });
    }
    repaintBundleOptions();

    if (bundleWrap) {
      var preSelected = bundleWrap.querySelector('[data-bundle-option].is-selected') || bundleWrap.querySelector('[data-bundle-option]');
      var preQty = preSelected ? parseInt(preSelected.getAttribute('data-bundle-qty'), 10) || 1 : 1;
      if (preSelected && quantityInput) {
        quantityInput.value = preQty;
      }
      bundleQty = preQty;
      bundleDiscount = preSelected ? parseInt(preSelected.getAttribute('data-bundle-discount'), 10) || 0 : 0;
      bundleDiscountAmount = preSelected ? readBundleDiscount(preSelected) : 0;
      bundleAddonVariantId = preSelected ? (preSelected.getAttribute('data-bundle-addon-variant') || null) : null;
      bundleAddonQty = bundleAddonVariantId ? (parseInt(preSelected.getAttribute('data-bundle-addon-qty'), 10) || 0) : 0;
      bundleAddonPrice = preSelected ? (parseInt(preSelected.getAttribute('data-bundle-addon-price'), 10) || 0) : 0;
      bundleGiftVariantId = preSelected ? (preSelected.getAttribute('data-bundle-gift-variant') || null) : null;
      bundleGiftPrice = bundleGiftVariantId ? (parseInt(preSelected.getAttribute('data-bundle-gift-price'), 10) || 0) : 0;
      syncPickForOption(preSelected);
      paintPickTier();
      showBundleColorRows(preQty);
      renderPrice();
      syncHighlights();
      syncBundleForVariant(currentVariant);
    }

    if (pickPanel) {
      pickPanel.addEventListener('change', function (e) {
        if (e.target === giftSelect) {
          if (bundlePick && bundleGiftVariantId) bundleGiftVariantId = giftSelect.value;
          return;
        }
        paintPickTier();
        renderPrice();
      });
    }

    // Utan paketväljare (t.ex. handsksidan) finns inget tillägg valt - kör en gång
    // ändå så att addon_only-punkter inte blir hängande synliga.
    syncHighlights();

    /* ---------- Parpaket: två personaliserade artiklar, två sidladdningar ----------
       Filuppladdning kan bara skickas via en riktig multipart-sidladdning, inte fetch,
       så "köp båda" går i två steg: lägg till artikel A (native submit, redirect hit
       igen med ?pair_step=2), sedan artikel B (native submit, redirect till /cart).
       Bilden för steg 2 kan inte sparas mellan sidladdningarna av webbläsarsäkerhets-
       skäl, så kunden väljer den bilden på nytt efter att steg 1 lagts till. */
    var pairBundle = section.querySelector('[data-pair-bundle]');
    if (pairBundle) {
      var pairTierButtons = pairBundle.querySelectorAll('[data-pair-tier]');
      var pairStepBanner = section.querySelector('[data-pair-step-banner]');
      var pairUploads = section.querySelector('[data-pair-uploads]');
      var pairFileA = section.querySelector('[data-pair-file="a"]');
      var pairFileB = section.querySelector('[data-pair-file="b"]');
      var pairNoteA = section.querySelector('[data-pair-note="a"]');
      var pairNoteB = section.querySelector('[data-pair-note="b"]');
      var pairBlockA = section.querySelector('[data-pair-upload-block="a"]');
      var pairBlockB = section.querySelector('[data-pair-upload-block="b"]');
      var pairReturnTo = section.querySelector('[data-pair-return-to]');
      var pairQuantityWrap = section.querySelector('[data-pair-quantity-wrap]');
      var pairBuyNow = section.querySelector('[data-pair-buy-now]');
      var singlePersonalization = section.querySelector('[data-personalization]');
      var pairOptionBlocks = section.querySelectorAll('[data-option-name]');

      var pairVariantA = pairBundle.getAttribute('data-variant-a');
      var pairVariantB = pairBundle.getAttribute('data-variant-b');
      var pairLabelA = pairBundle.getAttribute('data-label-a');
      var pairLabelB = pairBundle.getAttribute('data-label-b');
      var pairProductUrl = pairBundle.getAttribute('data-product-url');
      var pairSetMediaId = pairBundle.getAttribute('data-pair-set-media-id');
      var pairAddText = addToCartText ? addToCartText.textContent : t('add_to_cart');

      // Visa bilder för båda designerna i galleriet när "2 st" är valt, i stället
      // för att bara visa den ena variantens filtrerade bilder.
      function showAllGalleryImages() {
        section.querySelectorAll('[data-gallery-image]').forEach(function (img) { img.classList.remove('is-color-hidden'); });
        section.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-color-hidden'); });
        if (pairSetMediaId) setActiveMedia(pairSetMediaId);
      }
      function restoreGalleryFilter() {
        var selectedSwatch = section.querySelector('[data-color-label].is-selected');
        if (selectedSwatch) filterGalleryByColor(selectedSwatch.getAttribute('data-option-value'));
      }

      function setPairTier(tier) {
        var isSet = tier === 'set';
        pairTierButtons.forEach(function (btn) {
          var on = btn.getAttribute('data-pair-tier') === tier;
          btn.classList.toggle('is-selected', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (pairUploads) pairUploads.hidden = !isSet;
        pairOptionBlocks.forEach(function (el) { el.hidden = isSet; });
        if (singlePersonalization) singlePersonalization.hidden = isSet;
        if (pairQuantityWrap) pairQuantityWrap.hidden = isSet;
        if (pairBuyNow) pairBuyNow.hidden = isSet;

        if (isSet) {
          variantIdInput.value = pairVariantA;
          if (pairFileA) { pairFileA.disabled = false; pairFileA.required = true; }
          if (pairNoteA) pairNoteA.disabled = false;
          if (pairFileB) { pairFileB.disabled = true; pairFileB.required = false; }
          if (pairNoteB) pairNoteB.disabled = true;
          if (pairBlockA) pairBlockA.hidden = false;
          if (pairBlockB) pairBlockB.hidden = true;
          if (pairReturnTo) pairReturnTo.value = pairProductUrl + '?pair_step=2';
          if (addToCartText) addToCartText.textContent = t('pair_add', { label: pairLabelA });
          showAllGalleryImages();
        } else {
          if (pairFileA) { pairFileA.disabled = true; pairFileA.required = false; }
          if (pairNoteA) pairNoteA.disabled = true;
          if (pairFileB) { pairFileB.disabled = true; pairFileB.required = false; }
          if (pairNoteB) pairNoteB.disabled = true;
          if (addToCartText) addToCartText.textContent = pairAddText;
          restoreGalleryFilter();
        }
      }

      pairTierButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          setPairTier(btn.getAttribute('data-pair-tier'));
        });
      });

      var pairParams = new URLSearchParams(window.location.search);
      if (pairParams.get('pair_step') === '2') {
        setPairTier('set');
        if (pairStepBanner) {
          pairStepBanner.hidden = false;
          var msg = pairStepBanner.querySelector('p');
          if (msg) msg.textContent = t('pair_step2', { a: pairLabelA, b: pairLabelB });
        }
        variantIdInput.value = pairVariantB;
        if (pairFileA) { pairFileA.disabled = true; pairFileA.required = false; }
        if (pairNoteA) pairNoteA.disabled = true;
        if (pairBlockA) pairBlockA.hidden = true;
        if (pairFileB) { pairFileB.disabled = false; pairFileB.required = true; }
        if (pairNoteB) pairNoteB.disabled = false;
        if (pairBlockB) pairBlockB.hidden = false;
        if (pairReturnTo) pairReturnTo.value = ROOT + 'cart';
        if (addToCartText) addToCartText.textContent = t('pair_add', { label: pairLabelB });
      }
    }

    function submitAddToCart() {
      var qty = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
      addToCartBtn.disabled = true;
      if (addError) addError.hidden = true;
      var originalText = addToCartText ? addToCartText.textContent : '';
      if (addToCartText) addToCartText.textContent = t('adding');
      var mixedItems = bundleColors && !bundleColors.hidden ? bundleColorItems(qty) : null;
      var items = mixedItems || [{ id: variantIdInput.value, quantity: qty }];
      if (bundleAddonVariantId && bundleAddonQty > 0) {
        items = items.concat([{ id: bundleAddonVariantId, quantity: bundleAddonQty }]);
      }
      if (bundlePick && bundlePickVariantId) {
        items = items.concat([{ id: bundlePickVariantId, quantity: 1 }]);
      }
      if (bundleGiftVariantId) {
        var giftItem = { id: bundleGiftVariantId, quantity: 1 };
        // Vilket djur kunden har följer med som egenskap på gåvans rad.
        if (bundlePick && giftAnimal) {
          giftItem.properties = {};
          giftItem.properties[giftAnimal.getAttribute('data-property')] = giftAnimal.value;
        }
        items = items.concat([giftItem]);
      }
      var addPromise = (mixedItems || bundleAddonVariantId || bundleGiftVariantId || bundlePick) ? cartAddItems(items) : cartAdd(variantIdInput.value, qty);
      return addPromise
        .then(function () {
          if (addToCartText) addToCartText.textContent = originalText;
          addToCartBtn.disabled = false;
          // cartAdd/cartAddItems har allerede gengivet kurven via sections.
          openCartDrawer();
          if (addedMessage) {
            addedMessage.hidden = false;
            setTimeout(function () { addedMessage.hidden = true; }, 2200);
          }
        })
        .catch(function (err) {
          if (addToCartText) addToCartText.textContent = originalText;
          addToCartBtn.disabled = false;
          // Kurven er lukket, så fejlen skal stå ved knappen, ellers ser kunden
          // ingenting. Shopifys egen forklaring er mere brugbar end en generisk.
          var message = (err && err.description) || t('cart_error_add_retry');
          if (addError) {
            addError.textContent = message;
            addError.hidden = false;
            // Fra den klæbende købsbjælke står beskeden ofte uden for skærmen.
            var errRect = addError.getBoundingClientRect();
            if (errRect.top < 0 || errRect.bottom > window.innerHeight) {
              addError.scrollIntoView({ block: 'center', behavior: 'smooth' });
            }
          } else {
            showCartError(message);
          }
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        // Formulär med bilduppladdning (properties[Foto]) måste skickas som en
        // riktig sidladdning till /cart/add, inte fetch, annars når filen aldrig
        // Shopify. Webbläsarens inbyggda required-validering sköter obligatoriskt-fältet.
        var fileInput = form.querySelector('[data-personalization-file]');
        var pairFileInput = form.querySelector('[data-pair-file]:not([disabled])');
        var hasFile = (fileInput && fileInput.files && fileInput.files.length > 0)
          || (pairFileInput && pairFileInput.files && pairFileInput.files.length > 0);
        if (hasFile) {
          return;
        }
        e.preventDefault();
        submitAddToCart();
      });
    }

    var stickyAddBtn = document.querySelector('[data-sticky-add-to-cart]');
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', submitAddToCart);
    }
  });

  /* ---------- Bilduppladdning (dropzon) ---------- */
  // Filfältet ligger osynligt ovanpå zonen, så klick och släpp sköts av
  // webbläsaren. Här visas bara vald bild och markering under dragning.
  document.querySelectorAll('[data-dropzone]').forEach(function (zone) {
    var input = zone.querySelector('input[type="file"]');
    var icon = zone.querySelector('[data-dropzone-icon]');
    var preview = zone.querySelector('[data-dropzone-preview]');
    var title = zone.querySelector('[data-dropzone-title]');
    var hint = zone.querySelector('[data-dropzone-hint]');
    if (!input) return;
    var defaultTitle = title ? title.textContent : '';
    var defaultHint = hint ? hint.textContent : '';
    var previewUrl = null;

    function render() {
      var file = input.files && input.files[0];
      if (previewUrl) { URL.revokeObjectURL(previewUrl); previewUrl = null; }
      zone.classList.toggle('has-file', !!file);
      if (file && preview && /^image\//.test(file.type)) {
        previewUrl = URL.createObjectURL(file);
        preview.src = previewUrl;
        preview.hidden = false;
        if (icon) icon.hidden = true;
      } else {
        if (preview) { preview.hidden = true; preview.removeAttribute('src'); }
        if (icon) icon.hidden = false;
      }
      if (title) title.textContent = file ? file.name : defaultTitle;
      if (hint) hint.textContent = file ? t('change_image') : defaultHint;
    }

    input.addEventListener('change', render);
    ['dragenter', 'dragover'].forEach(function (type) {
      input.addEventListener(type, function () { zone.classList.add('is-dragover'); });
    });
    ['dragleave', 'drop'].forEach(function (type) {
      input.addEventListener(type, function () { zone.classList.remove('is-dragover'); });
    });
  });

  /* ---------- Review carousel ---------- */
  document.querySelectorAll('[data-review-carousel]').forEach(function (carousel) {
    var cards = carousel.querySelectorAll('[data-review-index]');
    var dots = carousel.querySelectorAll('[data-review-dot]');
    var current = 0;

    function show(index) {
      current = (index + cards.length) % cards.length;
      cards.forEach(function (card, i) { card.classList.toggle('is-active', i === current); });
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === current); });
    }

    var prevBtn = carousel.querySelector('[data-review-prev]');
    var nextBtn = carousel.querySelector('[data-review-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); });
    });

    // Bläddrar automatiskt var 5:e sekund. Pausar när besökaren håller musen
    // över, rör vid eller fokuserar karusellen, när fliken är dold och helt
    // om besökaren valt reducerad rörelse. Ett manuellt klick startar om tiden.
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (cards.length < 2 || reduceMotion) return;
    var timer = null;
    var paused = false;
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (paused || document.hidden) return;
      timer = setInterval(function () { show(current + 1); }, 5000);
    }
    carousel.addEventListener('mouseenter', function () { paused = true; stop(); });
    carousel.addEventListener('mouseleave', function () { paused = false; start(); });
    carousel.addEventListener('focusin', function () { paused = true; stop(); });
    carousel.addEventListener('focusout', function () { paused = false; start(); });
    carousel.addEventListener('touchstart', function () { stop(); setTimeout(start, 8000); }, { passive: true });
    carousel.addEventListener('click', function (e) {
      if (e.target.closest('[data-review-prev], [data-review-next], [data-review-dot]')) start();
    });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  });
})();

/* ---------- Shopify Forms-teaser ovanför köpbaren ----------
   Rabatt-teasern ("10% off") ligger fast nere till höger och täckte både
   "Lägg i varukorg" i den fasta köpbaren och "Avvisa" i cookiebannern. Appen
   har ingen inställning för avstånd, så en stil läggs in i dess shadow DOM och
   lyfter teasern över det som ligger i botten. Byter Shopify klassnamn slutar
   det bara att verka; teasern hamnar då där appen själv lägger den. */
(function () {
  var STYLE = '.appEmbed:has([class*="teaserContainer"]){bottom:var(--nf-teaser-offset,0px)!important;transition:bottom .2s ease}';
  var BOTTOM_BARS = '.sticky-cart-bar, .shopify-pc__banner__dialog';

  function updateOffset() {
    var offset = 0;
    document.querySelectorAll(BOTTOM_BARS).forEach(function (el) {
      var r = el.getBoundingClientRect();
      var cs = getComputedStyle(el);
      if (r.height === 0 || cs.display === 'none' || cs.visibility === 'hidden' || +cs.opacity === 0) return;
      if (r.top >= window.innerHeight) return;
      offset = Math.max(offset, window.innerHeight - r.top);
    });
    document.documentElement.style.setProperty('--nf-teaser-offset', (offset ? offset + 8 : 0) + 'px');
  }

  function injectStyle() {
    document.querySelectorAll('shopify-forms-embed').forEach(function (host) {
      var root = host.shadowRoot;
      if (!root || root.querySelector('style[data-nf-teaser]')) return;
      var style = document.createElement('style');
      style.setAttribute('data-nf-teaser', '');
      style.textContent = STYLE;
      root.appendChild(style);
    });
  }

  var ticks = 0;
  var timer = setInterval(function () {
    injectStyle();
    updateOffset();
    if (++ticks > 40) clearInterval(timer);
  }, 500);

  var queued = false;
  function queueUpdate() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; updateOffset(); });
  }
  window.addEventListener('scroll', queueUpdate, { passive: true });
  window.addEventListener('resize', queueUpdate);
  // Cookiebannern försvinner vid klick; räkna om när den har animerats bort.
  document.addEventListener('click', function () { setTimeout(updateOffset, 400); });
})();
